import { SPLIT_LAYOUT_EXPAND_FRACTION } from './constants';

/** The width (px) the panel would expand to for the split layout, before clamping to its bounds. */
export const getSplitLayoutTargetWidth = (): number =>
	Math.ceil(SPLIT_LAYOUT_EXPAND_FRACTION * window.innerWidth);
